import { memo as Memo, useCallback, useEffect } from 'react';
import { gsap } from 'gsap';

const SeoEyes = Memo(() => {
	useEffect(() => {
		window.addEventListener('mousemove', mouseMove);
		return () => {
			window.removeEventListener('mousemove', mouseMove);
		};
	}, []);

	const mouseMove = useCallback((e) => {
		const size = -5;
		const winWPart = window.innerWidth / 2;
		const winHPart = window.innerHeight / 2;
		const x = ((winWPart - e.clientX) / winWPart) * size;
		const y = ((winHPart - e.clientY) / winHPart) * size;

		gsap.killTweensOf('.SeoEyes-e');
		gsap.killTweensOf('.SeoEyes-m');

		gsap.to('.SeoEyes-e', { duration: 0.5, x, y });
		gsap.to('.SeoEyes-m', { duration: 0.5, x: x * 0.8, y: y * 0.8 });
	}, []);

	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			className='ziggyEyes svg-max'
			viewBox='0 0 166.67 232.69'>
			<g>
				<path d='M61.66,232.61c-.75,0-1.45-.49-1.68-1.25-.27-.93.25-1.9,1.18-2.18l4.39-1.3c3.34-.99,5.68-3.87,5.97-7.33.37-4.39.82-30.47,1.21-53.48.33-18.85.61-35.12.8-37.25.09-.96.94-1.67,1.9-1.58.96.09,1.67.94,1.58,1.9-.18,2-.47,19-.78,37-.4,23.07-.85,49.21-1.22,53.72-.41,4.92-3.73,9-8.46,10.4l-4.39,1.3c-.17.05-.33.07-.5.07Z' />
				<path d='M105.01,232.61c-.17,0-.33-.02-.5-.07l-4.39-1.3c-4.73-1.4-8.05-5.49-8.46-10.4-.38-4.51-.83-30.65-1.22-53.72-.31-17.99-.6-34.99-.78-36.99-.09-.96.62-1.81,1.59-1.9.96-.09,1.81.62,1.9,1.59.19,2.13.47,18.4.8,37.25.4,23.02.85,49.1,1.21,53.49.29,3.47,2.63,6.35,5.97,7.33l4.39,1.3c.93.28,1.45,1.25,1.18,2.18-.23.76-.92,1.25-1.68,1.25Z' />
			</g>
			<polygon points='83.34 0 0 138.5 166.67 138.5 83.34 0' />
			<path
				fill='var(--color1)'
				className='SeoEyes-e'
				d='M67.19,118.11l4.86-11.01h4.32l-7.2,15.99h-4.02l-7.2-15.99h4.29l4.95,11.01Z'
			/>
			<path
				fill='var(--color1)'
				className='SeoEyes-e'
				d='M101.45,118.11l4.86-11.01h4.32l-7.2,15.99h-4.02l-7.2-15.99h4.29l4.95,11.01Z'
			/>
		</svg>
	);
});

export default SeoEyes;
